import React from 'react';
import { SharedIconComponent } from '../../shared-components/icon';
export var ICON_TYPE_TEST_ID = 'link-datasource-render-type--icon';
export var ICON_TYPE_TEXT_TEST_ID = "".concat(ICON_TYPE_TEST_ID, "-text");
var IconRenderType = function IconRenderType(_ref) {
  var label = _ref.label,
    text = _ref.text,
    source = _ref.source,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? ICON_TYPE_TEST_ID : _ref$testId;
  return /*#__PURE__*/React.createElement(SharedIconComponent, {
    testId: testId,
    iconUrl: source,
    label: label,
    text: text
  });
};
export default IconRenderType;